import { STRUCTURE_GRID_SIZE } from 'data/constants';
import { FootprintPolygonsType, GridSpaceDataType } from 'data/types';
import { footprintBoundingBox } from 'utils/footprint-polygons';

export type OverlayBounds = {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
};

export function getStructureOverlayBounds(
  gridSpaces: GridSpaceDataType[],
  footprintPolygons: FootprintPolygonsType | null | undefined
): OverlayBounds | null {
  const bb = footprintBoundingBox(footprintPolygons ?? []);
  if (bb) {
    return {
      minX: bb.minX * STRUCTURE_GRID_SIZE,
      minY: bb.minY * STRUCTURE_GRID_SIZE,
      maxX: bb.maxX * STRUCTURE_GRID_SIZE,
      maxY: bb.maxY * STRUCTURE_GRID_SIZE
    };
  }

  if (gridSpaces.length === 0) return null;

  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (const space of gridSpaces) {
    const { x, y, width, height } = space.position;
    if (x < minX) minX = x;
    if (y < minY) minY = y;
    if (x + width > maxX) maxX = x + width;
    if (y + height > maxY) maxY = y + height;
  }
  return { minX, minY, maxX, maxY };
}
